import { useEffect, useState, useMemo } from "react";
import React from 'react';
import ReactTableWrapper from "../../components/ReactTableWrapper";
import "../../App.css";
import { useCookies } from 'react-cookie';
import {Row, Col, Button} from "reactstrap";
import { default as ReactSelect } from "react-select";
import { DatePicker } from 'antd';
import { getUserAllowedPlants} from '../../services/PlantServices';
import { getAllCustomerMain} from '../../services/CustomerMainServices';
import { getAllSalesRepresentatives } from '../../services/SalesRepresentativeServices';
import {getAllCustomerSites} from '../../services/CustomerSiteServices';
import { getAllProducts } from "../../services/ProductServices";
import { getAllEquipments } from '../../services/EquipmentServices';
import {getEquipmentReport} from "../../services/ReportServices";
import moment  from 'moment';
import { ValueContainer, Option } from "../../components/MultiSelectControls";
const {RangePicker} = DatePicker;

function EquipmentReportTable() {
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const [refreshKey, setRefreshKey] = useState(0);
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(true); 
    const [plants, setPlants] = React.useState([]);
    const [selectedPlant, setSelectedPlant] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [selectedSalesrep, setSelectedSalesRep] = useState(null);
    const [salesreps, setSalesreps] = useState([]);
    const [selectedSite, setSelectedSite] = useState(null);
    const [sites, setSites] = useState([]);
    const [selectedVehicleno, setSelectedVehicleno] = useState(null);
    const [vehicles, setVehicles] = useState([]);
    const [selectedGrade, setSelectedGrade] = useState(null);
    const [grades, setGrades] = useState([]);
    const currentMonthStartDate = moment().startOf('month');
    const currentDate = moment();
    const [dates, setDates] = useState([currentMonthStartDate, currentDate]);
   

    React.useEffect(() => {
        
        //Load data for Plant dropdown
        getUserAllowedPlants(cookies)
        .then (
            plantList => {
                
                const plants = plantList.plant_list.filter(obj => obj.status).map(
                    plant => {
                        return { value: plant.id, label: plant.entity_name }
                    }
                );
                setPlants(plants);
            }
        )
    }, []);
    React.useEffect(() => {
        getAllCustomerMain(cookies)
        .then (
            customerList => {
                
                const customers = customerList.customer_list.filter(obj => obj.status).map(
                    customer => {
                        return { value: customer.id, label: customer.name }
                    }
                );
                setCustomers(customers);
            }
        )
    }, []);
    React.useEffect(() => {
    getAllCustomerSites(cookies)
    .then (
        siteList => {
            
            const sites = siteList.consignee_list.filter(obj => obj.status).map(
                site => {
                    return { value: site.id, label: site.name }
                }
            );
            setSites(sites);
        }
    )
}, []);

React.useEffect(() => {
    getAllSalesRepresentatives(cookies)
    .then (
        salesRepList => {
            
            const salesrep = salesRepList.salesrep_data.filter(obj => obj.status).map(
              sales => {
                    return { value: sales.id, label: sales.entity_name }
                }
               
            );
            //console.log(JSON.stringify(salesRepList)+"salesRepList")
        
            setSalesreps(salesrep);
          
        }
    )
}, []);
React.useEffect(() => {
    getAllEquipments(cookies)
      .then (
      
         equipmentObject => {
          
              const equipments = equipmentObject.equipment_list.filter(obj => (obj.status) ).map(
                  equipment => {
                      return { value: equipment.id, label: equipment.equip_name}
                  }
              );
              setVehicles(equipments);
          }
      )
  }, []);

React.useEffect(() => {
    getAllProducts(cookies)
    .then (
        productList => {
            
            const products = productList.product_list.filter(obj => obj.status).map(
                product => {
                    return { value: product.id, label: product.name}
                }
            )
           
            setGrades(products);
        }
    )
}, []);


    const onPlantSelect = (selected) => {
        setSelectedPlant(selected);
    };
    const onCustomerSelect = (selected) => {
        
        setSelectedCustomer(selected);
    };

    const onSiteSelect = (selected) => {
        setSelectedSite(selected);

    };
    const onSalesRepSelect = (selected) => {
        setSelectedSalesRep(selected);
    };


    const onVehiclenoSelect = (selected) => {
        setSelectedVehicleno(selected);
    };
    const onGradeSelect = (selected) => {
        setSelectedGrade(selected);
    };

    const columns = useMemo(
        () => [
            {
                fieldName: 'entity_name', 
                headerName: 'Plant Name'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Production Plant'
            },
           
            {
                fieldName: "address",
                headerName: 'Date'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'DC Number'
            },
          
            {
                fieldName: "mobile_number",
                headerName: 'Batch Number'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Time'
            },
            {
                fieldName: "address",
                headerName: 'SO Number'
            },
            {
                fieldName: "address",
                headerName: 'PO Number'
            },
            {
                fieldName: "address",
                headerName: 'Invoice Number'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Customer Name'
            },
            {
                fieldName: "address",
                headerName: 'Site/Project Name'
            },
            {
                fieldName: "address",
                headerName: 'Grade'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Quantity'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Rate'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Mode of Delivery'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Vehicle No'
            },
            
            {
                fieldName: "address",
                headerName: 'Marketting'
            },
            {
                fieldName: "address",
                headerName: 'Driver name'
            },
            {
                fieldName: "address",
                headerName: 'Open KM'
            },
            {
                fieldName: "address",
                headerName: 'End KM'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'DC Grade'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Total Km'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Tare weight'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Gross weight'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Net weight'
            },
            {
                fieldName: "address",
                headerName: 'Dc Status'
            },
           
        ],
        [],);

    useEffect(() => {

        getEquipmentReport(cookies)
        .then( customerList => {
            const tableData = customerList.salesrep_data
            .map(customer => ({
                entity_name: customer.entity_name,
                address: [customer.address_1, customer.address_2, customer.address_3].filter(Boolean).join(',\n'),
                phone_number:customer.phone_number,
                mobile_number:customer.mobile_number,
                status:customer.status,
                id: customer.id,    
            }));

            setData({
                total: data.total,
                records: tableData
            });
            setIsLoading(false);
        });
        }, [refreshKey]);
    
    const handleGenerate = () => {
        setIsLoading(true);
        setRefreshKey((key) => key + 1);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        handleGenerate();
    };

    return (
        <div className="report-embedded-page">
            <form className="form" onSubmit={handleSubmit}>
                <div className="container">
                    <Row>
                        <Col xl={12} lg={12} md={12}>
                            <div className="report-legacy-filters form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel">
                                <div className="report-legacy-filters-fields">
                                    <ReactSelect
                                        options={plants}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        components={{ Option, ValueContainer }}
                                        isClearable
                                        value={selectedPlant}
                                        onChange={onPlantSelect}
                                        className="react-select-dropdown col-sm-3"
                                        placeholder="Please select Plant name"
                                    />
                                    <ReactSelect
                                        options={customers}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        components={{ Option, ValueContainer }}
                                        isClearable
                                        value={selectedCustomer}
                                        onChange={onCustomerSelect}
                                        className="react-select-dropdown col-sm-3"
                                        placeholder="Please select Customer"
                                    />
                                    <ReactSelect
                                        options={sites}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        components={{ Option, ValueContainer }}
                                        isClearable
                                        value={selectedSite}
                                        onChange={onSiteSelect}
                                        className="react-select-dropdown col-sm-3"
                                        placeholder="Please Select Site"
                                    />
                                    <ReactSelect
                                        options={salesreps}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        components={{ Option, ValueContainer }}
                                        isClearable
                                        value={selectedSalesrep}
                                        onChange={onSalesRepSelect}
                                        className="react-select-dropdown col-sm-3"
                                        placeholder="Please Select SalesRep"
                                    />
                                    <ReactSelect
                                        options={vehicles}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        components={{ Option, ValueContainer }}
                                        isClearable
                                        value={selectedVehicleno}
                                        onChange={onVehiclenoSelect}
                                        className="react-select-dropdown col-sm-3"
                                        placeholder="Please Select Vehicle"
                                    />
                                    <ReactSelect
                                        options={grades}
                                        isMulti
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        components={{ Option, ValueContainer }}
                                        isClearable
                                        value={selectedGrade}
                                        onChange={onGradeSelect}
                                        className="react-select-dropdown col-sm-3"
                                        placeholder="Please Select Grade"
                                    />
                                </div>
                                <div className="report-legacy-filters-row">
                                    <RangePicker
                                        value={dates}
                                        format="DD-MM-YYYY"
                                        onChange={(values) => {
                                            if (values && values.length === 2) {
                                                setDates(values);
                                            }
                                        }}
                                        style={{ width: '270px' }}
                                    />
                                    <select
                                        className="browser-default custom-select col-sm-3"
                                        style={{ width: '200px' }}
                                        defaultValue=""
                                    >
                                        <option value="">Please Select Report</option>
                                        <option value="date">Datewise</option>
                                        <option value="product">Product</option>
                                        <option value="vendor">Supplier</option>
                                        <option value="vehicle">Vehicle</option>
                                    </select>
                                    <div className="report-legacy-actions">
                                        <Button
                                            color="primary"
                                            className="list-page-toolbar-generate-btn"
                                            type="submit"
                                            disabled={isLoading}
                                        >
                                            Generate
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </form>
            <div className="container">
                <div className="list-page-table-wrap">
                    <div className="item-list-table-container">
                        <div className="table-responsive">
                            <ReactTableWrapper
                                title="Equipment Report"
                                columns={columns}
                                data={data.records}
                                exportFilename="equipment_report"
                                isLoading={isLoading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default EquipmentReportTable;